// extracted by mini-css-extract-plugin
export default {"container":"DateWithExpiration_container__okXEu","date":"DateWithExpiration_date__ufpHn","expired":"DateWithExpiration_expired__mmpQE"};